import React from 'react'
import PropTypes from 'prop-types'
import './Characters.styles.css'

export default function SectionTabs({ activeTab, onChangeTab, militaryCounts, civilianCounts }) {
  const isMilitary = activeTab === 'military'
  const isCivilian = activeTab === 'civilian'

  return (
    <div className="sectionTabs" role="tablist" aria-label="Tipo de personajes">
      <button
        type="button"
        role="tab"
        aria-selected={isMilitary}
        className={`sectionTab ${isMilitary ? 'active' : ''}`}
        onClick={() => onChangeTab('military')}
      >
        <span className="sectionTab__glyph" aria-hidden="true">
          忍
        </span>
        <span className="sectionTab__label">Militares</span>
        <span className="tabBadge">
          {militaryCounts.used} / {militaryCounts.total}
        </span>
      </button>

      <button
        type="button"
        role="tab"
        aria-selected={isCivilian}
        className={`sectionTab ${isCivilian ? 'active' : ''} sectionTab--soon`}
        onClick={() => onChangeTab('civilian')}
        title="Próximamente"
      >
        <span className="sectionTab__glyph" aria-hidden="true">
          民
        </span>
        <span className="sectionTab__label">Civiles</span>
        <span className="tabBadge tabBadge--muted">próx.</span>
      </button>
    </div>
  )
}

SectionTabs.propTypes = {
  activeTab: PropTypes.oneOf(['military', 'civilian']).isRequired,
  onChangeTab: PropTypes.func.isRequired,
  militaryCounts: PropTypes.shape({
    used: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  civilianCounts: PropTypes.shape({
    used: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
}
